export default "assets/images/flags/jp-731cef26.svg";